class HttpServiceError {
    ex;
    request;
    response;
    
    constructor({ ex, request, response }) {
        this.ex = ex;
        this.request = request;
        this.response = response;
    }
}

export { HttpServiceError }


// WEBPACK FOOTER //
// ./src/common/api/httpServiceError.js